import React from 'react';
import Layout from '../components/Layout';
import Root from '../components/Root';

export default function Home() {
  return (
    <Layout>
      <Root is404={false} />
    </Layout>
  );
}
